module.exports = function isCustomTextSpotlight(spotlight) {
    const custom = spotlight.fields.filter(field => {
        return field.field_type === 'input' && field.key === 'text'
    })
    return !! custom[0]
}
